export class CycleGlobalModel {

    /**
     * Staked tokens in previous round
     */
    previous_staked_tokens: bigint = BigInt(0);

    /**
     * Reward coins in previous round
     */
    previous_reward_coins: bigint = BigInt(0);

    /**
     * Reward tokens in previous round
     */
    previous_reward_tokens: bigint = BigInt(0);

    /**
     * Unclaimed coins in previous round
     */
    previous_unclaimed_coins: bigint = BigInt(0);

    /**
     * Unclaimed tokens in previous round
     */
    previous_unclaimed_tokens: bigint = BigInt(0);

    /**
     * Timestamp of previous round
     */
    previous_timestamp: bigint = BigInt(0);

    /**
     * Staked tokens for next round
     */
    next_staked_tokens: bigint = BigInt(0);

    /**
     * Pending coins for next round
     */
    next_reward_coins: bigint = BigInt(0);

    /**
     * Pending tokens for next round
     */
    next_reward_tokens: bigint = BigInt(0);

    /**
     * Fill values
     * 
     * @param values 
     */
    fill(values: Array<any>) {
        this.previous_staked_tokens = this.format(values, 'previous_staked_tokens');
        this.previous_reward_coins = this.format(values, 'previous_reward_coins');
        this.previous_reward_tokens = this.format(values, 'previous_reward_tokens');
        this.previous_unclaimed_coins = this.format(values, 'previous_unclaimed_coins');
        this.previous_unclaimed_tokens = this.format(values, 'previous_unclaimed_tokens');
        this.previous_timestamp = this.format(values, 'previous_timestamp');
        this.next_staked_tokens = this.format(values, 'next_staked_tokens');
        this.next_reward_coins = this.format(values, 'next_reward_coins');
        this.next_reward_tokens = this.format(values, 'next_reward_tokens');
    }

    /**
     * Format value
     * 
     * @param values
     * @param app
     * @param key
     */
    private format(values: Array<any>, key: string): bigint {
        let value = values.find(x => x.key == 'cycle_' + key);
        if (value) {
            return BigInt(value.value);
        } else {
            return BigInt(0);
        }
    }
}